import { IcBoussoleNord } from '@assets/icons/40x40/mapMenu';
import { Icon } from '@chakra-ui/react';
import { useMapContext } from '@components/map/MapContext';
import { ButtonBar } from '@components/ui/buttonBar';
import { useIntl } from 'react-intl';

export function NavigationControl() {
  const { formatMessage } = useIntl();
  const { isNorthLocked, setIsNorthLocked } = useMapContext();

  return (
    <ButtonBar.Root
      aria-label={formatMessage({ id: 'controls.toolMenu.north' })}
      notchPlacement="bottom-left"
      tooltipPlacement="left"
      data-active={isNorthLocked}
      onClick={() => setIsNorthLocked(!isNorthLocked)}
    >
      <ButtonBar.Control>
        <Icon as={IcBoussoleNord} />
      </ButtonBar.Control>
    </ButtonBar.Root>
  );
}
